export { default } from './daily-favorites'
